import { SupabaseClient } from '@supabase/supabase-js';

/**
 * Base service class that provides common functionality for all services
 */
export class BaseService {
  constructor(protected supabase: SupabaseClient) {}
  
  /**
   * Adds timestamps to data objects
   * @param data The data object to add timestamps to
   * @param isNew Whether this is a new record (adds created_at if true)
   * @returns The data with timestamps added
   */
  protected addTimestamps<T extends Record<string, any>>(data: T, isNew = false): T & { updated_at: string, created_at?: string } {
    const now = new Date().toISOString();
    
    if (isNew) {
      return {
        ...data,
        created_at: now,
        updated_at: now
      };
    }
    
    return {
      ...data,
      updated_at: now
    };
  }
  
  /**
   * Handles database errors consistently
   * @param error The error object
   * @param operation Description of the operation that failed
   */
  protected handleError(error: any, operation: string): void {
    console.error(`Error ${operation}:`, error.message || error);
    // You could also send errors to a monitoring service here
  }
}
